if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton && this.submitButton.querySelector('span');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      getCart() {
        // Prefer the cart drawer popup (Your cart side panel)
        return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner, .loading-spinner');
        if (spinner) spinner.classList.remove('hidden');
        this._originalButtonText = this.submitButtonText ? this.submitButtonText.textContent : '';

        const cart = this.getCart();
        if (cart && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cart
              .getSectionsToRender()
              .map((section) => section.id)
              .join(',')
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') {
            cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.error = false;

            // Open cart drawer FIRST (before pub/sub — subscribers must not block popup)
            const openCartPopup = () => {
              // Close homepage / collection product popup banner if open
              document.querySelectorAll('.product-modal.active').forEach((modal) => {
                modal.classList.remove('active');
              });
              if (!document.querySelector('cart-drawer.active')) {
                document.body.style.overflow = '';
              }

              const liveCart =
                document.querySelector('cart-drawer') ||
                window.cartDrawer ||
                document.querySelector('cart-notification');
              if (liveCart && typeof liveCart.renderContents === 'function') {
                if (liveCart.classList) liveCart.classList.remove('is-empty');
                liveCart.renderContents(response);
              } else if (liveCart && typeof liveCart.open === 'function') {
                liveCart.open();
              } else {
                this.updateCartIconBubble();
              }
            };

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(openCartPopup);
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              openCartPopup();
            }

            try {
              if (!this.error) {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              }
            } catch (pubErr) {
              console.error(pubErr);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            const liveCart = this.getCart();
            if (liveCart && liveCart.classList.contains('is-empty')) liveCart.classList.remove('is-empty');
            if (spinner) spinner.classList.add('hidden');
            if (!this.error) {
              this.updateCartIconBubble();
              if (this.submitButtonText) {
                this.submitButtonText.textContent = window.variantStrings.addedToCart || 'Added to cart';
                setTimeout(() => {
                  this.submitButtonText.textContent = this._originalButtonText;
                  this.submitButton.removeAttribute('aria-disabled');
                }, 2000);
              } else {
                this.submitButton.removeAttribute('aria-disabled');
              }
            } else {
              this.submitButton.removeAttribute('aria-disabled');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      updateCartIconBubble() {
        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            const el = document.getElementById('cart-icon-bubble');
            if (!el) return;
            const count = cart.item_count;
            let bubble = el.querySelector('.cart-count-bubble');
            if (count > 0) {
              if (!bubble) {
                bubble = document.createElement('div');
                bubble.className = 'cart-count-bubble';
                el.appendChild(bubble);
              }
              bubble.innerHTML =
                (count < 100 ? `<span aria-hidden="true">${count}</span>` : '') +
                `<span class="visually-hidden">${count}</span>`;
            } else if (bubble) {
              bubble.remove();
            }
          })
          .catch(() => {});
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
